import React, { useState } from 'react'
import styles from './CreateForumModal.module.scss'

const CreateForumModal = ({ isOpen, onClose, onSubmit, categories = [] }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    category: '',
    is_private: false
  })
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({})

  if (!isOpen) return null

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }))
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }))
    }
  }

  const validateForm = () => {
    const newErrors = {}

    if (!formData.name.trim()) {
      newErrors.name = 'Название форума обязательно'
    }

    if (!formData.description.trim()) {
      newErrors.description = 'Описание обязательно'
    }

    if (!formData.category) {
      newErrors.category = 'Выберите категорию'
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!validateForm()) {
      return
    }

    setLoading(true)
    try {
      const submitData = {
        name: formData.name.trim(),
        description: formData.description.trim(),
        category: formData.category,
        is_private: formData.is_private
      }

      await onSubmit(submitData)
      
      setFormData({
        name: '',
        description: '',
        category: '',
        is_private: false
      })
      setErrors({})
      onClose()
    } catch (error) {
      console.error('Ошибка создания форума:', error)
      setErrors({
        submit: error.response?.data?.detail || 'Ошибка создания форума'
      })
    } finally {
      setLoading(false)
    }
  }

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <div className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <div className={styles.headerContent}>
            <span className={styles.icon}>🏛️</span>
            <h2>Создать новый форум</h2>
          </div>
          <button 
            className={styles.closeButton}
            onClick={onClose}
            type="button"
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.formGroup}>
            <label htmlFor="name">
              Название форума <span className={styles.required}>*</span>
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Например: Общее обсуждение"
              className={errors.name ? styles.inputError : ''}
              disabled={loading}
            />
            {errors.name && (
              <span className={styles.errorMessage}>{errors.name}</span>
            )}
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="description">
              Описание <span className={styles.required}>*</span>
            </label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Опишите тематику форума"
              rows={4}
              className={errors.description ? styles.inputError : ''}
              disabled={loading}
            />
            {errors.description && (
              <span className={styles.errorMessage}>{errors.description}</span>
            )}
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="category">
              Категория <span className={styles.required}>*</span>
            </label>
            <select
              id="category"
              name="category"
              value={formData.category}
              onChange={handleInputChange}
              className={errors.category ? styles.inputError : ''}
              disabled={loading}
            >
              <option value="">Выберите категорию</option>
              {categories.map(category => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
            {errors.category && (
              <span className={styles.errorMessage}>{errors.category}</span>
            )}
          </div>

          <div className={styles.checkboxGroup}>
            <label className={styles.checkboxLabel}>
              <input
                type="checkbox"
                name="is_private"
                checked={formData.is_private}
                onChange={handleInputChange}
                disabled={loading}
              />
              <span>🔒 Приватный форум (только по приглашению)</span>
            </label>
          </div>

          {errors.submit && (
            <div className={styles.submitError}>
              {errors.submit}
            </div>
          )}

          <div className={styles.formActions}>
            <button
              type="button"
              onClick={onClose}
              className={styles.cancelButton}
              disabled={loading}
            >
              Отмена
            </button>
            <button
              type="submit"
              className={styles.submitButton}
              disabled={loading}
            >
              {loading ? 'Создание...' : '🏛️ Создать форум'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default CreateForumModal
